import { FC } from 'react';
import { Section } from './ui/Section';
import { EntryBlock } from './ui/EntryBlock';
import type { Entry } from '../types/cv';

interface Props {
  projects: Entry[];
  title?: string;
}

export const Projects: FC<Props> = ({ projects, title = 'Projects' }) => (
  <Section title={title}>
    {projects.map((project, i) => (
      <EntryBlock
        key={`${project.name}-${i}`}
        entry={project}
        title={project.name}
        role={<span className="cv-sub">{project.role}</span>}
        note={project.summary}
      />
    ))}
  </Section>
);

export default Projects;
